export const SET_START = 'SET_START';
export const SET_STEP = 'SET_STEP';
export const SET_DATA = 'SET_DATA';
export const SET_END = 'SET_END';
export const TACTICAL_UPGRADE_JOURNEY = 'TACTICAL_UPGRADE_JOURNEY';
